import { makeStyles } from '@itsa.io/ui';

export default makeStyles(() => ({
	root: {},
}));
